import React, { useState } from 'react';
import { Button } from './ui/button';
import { useHashPackWallet } from '../contexts/HashPackWalletContext';
import WalletModal from './WalletModal';

declare global {
  interface Window {
    ethereum?: any;
  }
}

const WalletStatus: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { isConnected, accountId, disconnect } = useHashPackWallet();

  const displayAddress = accountId;

  const handleConnect = () => {
    setIsModalOpen(true);
  };

  const formatAddress = (address: string) => {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  const handleDisconnect = async () => {
    try {
      await disconnect();
    } catch (error) {
      console.error('Error disconnecting:', error);
    }
  };

  if (isConnected) {
    return (
      <div className="flex items-center space-x-2">
        <Button variant="outline" className="bg-gradient-to-r from-green-500/20 to-blue-500/20 border-green-500/30 text-green-400 hover:from-green-500/30 hover:to-blue-500/30 transition-all duration-300">
          <span className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></span>
          {formatAddress(displayAddress || '')}
        </Button>
        <Button
          onClick={handleDisconnect}
          variant="outline"
          size="sm"
          className="border-red-500/30 text-red-400/70 hover:bg-red-500/20 hover:text-red-400"
        >
          Disconnect
        </Button>
      </div>
    );
  }

  return (
    <>
      <Button 
        onClick={() => setIsModalOpen(true)}
        variant="outline" 
        className="border-green-500/30 text-green-400/70 hover:bg-green-500/20 hover:text-green-400 transition-all duration-300 hover:scale-105"
      >
        <span className="mr-2">🔗</span>
        Connect Wallet
      </Button>
      <WalletModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default WalletStatus;
